var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "settings" }, [
    _c("p", { staticClass: "lead" }, [_vm._v("記事を作成する")]),
    _vm._v(" "),
    _c("div", { staticClass: "settings__item" }, [
      _c("p", { staticClass: "settings__item__title" }, [
        _vm._v(
          "\n      記事のタイトル（推奨" +
            _vm._s(_vm.recommendedTitleLength) +
            "文字以内、最大" +
            _vm._s(_vm.maxTitleLength) +
            "文字以内）\n    "
        )
      ]),
      _vm._v(" "),
      _c("input", {
        directives: [
          {
            name: "model",
            rawName: "v-model",
            value: _vm.title,
            expression: "title"
          }
        ],
        staticClass: "settings__item__inputText",
        attrs: {
          type: "text",
          placeholder: "タイトルを入力",
          maxlength: _vm.maxTitleLength,
          required: ""
        },
        domProps: { value: _vm.title },
        on: {
          blur: function($event) {
            _vm.trackTitle()
          },
          input: function($event) {
            if ($event.target.composing) {
              return
            }
            _vm.title = $event.target.value
          }
        }
      })
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "settings__item" }, [
      _c("p", { staticClass: "settings__item__title" }, [
        _vm._v("表示する記事一覧ページを選択")
      ]),
      _vm._v(" "),
      _c("small", { staticClass: "settings__item__info" }, [
        _vm._v("ここで指定した一覧ページに記事が表示されます。")
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "settings__item__editContentListPage",
          attrs: { href: _vm.editContentListPage }
        },
        [_vm._v("＋新しいページを追加")]
      ),
      _vm._v(" "),
      _c(
        "select",
        {
          directives: [
            {
              name: "model",
              rawName: "v-model",
              value: _vm.categoryId,
              expression: "categoryId"
            }
          ],
          staticClass: "esModalCategory",
          attrs: { required: "" },
          on: {
            change: [
              function($event) {
                var $$selectedVal = Array.prototype.filter
                  .call($event.target.options, function(o) {
                    return o.selected
                  })
                  .map(function(o) {
                    var val = "_value" in o ? o._value : o.value
                    return val
                  })
                _vm.categoryId = $event.target.multiple
                  ? $$selectedVal
                  : $$selectedVal[0]
              },
              function($event) {
                _vm.trackCategory()
              }
            ]
          }
        },
        _vm._l(_vm.categoryData, function(articleCategory) {
          return _c(
            "option",
            {
              staticClass: "esModalCategory__item",
              domProps: { value: articleCategory.categoryId }
            },
            [
              _vm._v(
                "\n        " +
                  _vm._s(articleCategory.categoryName) +
                  " (" +
                  _vm._s(articleCategory.contentCount) +
                  ")\n      "
              )
            ]
          )
        })
      )
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "buttonDialogPosition" }, [
      _c(
        "button",
        {
          staticClass: "button large",
          attrs: { disabled: _vm.unsubmittable },
          on: { click: _vm.submitEvent }
        },
        [_vm._v("作成\n    ")]
      )
    ]),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "close-button",
        attrs: { "aria-label": "Close modal", type: "button" },
        on: { click: _vm.close }
      },
      [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }